import request from '@/utils/request'

export function login(username, password) {
  const domain = process.env.VUE_APP_DOMAIN_URL
  return request({
    url: domain + 'shop/oauth/token',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/user',
    method: 'get'
  })
}
